import { render, staticRenderFns } from "./compat.svg.vue?vue&type=template&id=1bce4f99"
import script from "./compat.svg.vue?vue&type=script&lang=ts"
export * from "./compat.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bce4f99')) {
      api.createRecord('1bce4f99', component.options)
    } else {
      api.reload('1bce4f99', component.options)
    }
    module.hot.accept("./compat.svg.vue?vue&type=template&id=1bce4f99", function () {
      api.rerender('1bce4f99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/landing/LandingContentBox/compat.svg.vue"
export default component.exports